import axios from "axios";
import { DEFAULT_API_CONFIG } from "./apiConfig";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: DEFAULT_API_CONFIG,
  headers: { "Content-Type": "application/json" },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve auth token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
      toast.error('Session Expired')
      console.error("Unauthorized as status 401");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;